
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":"18","height":"18","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Material-Icons"}},[_c('g',{attrs:{"id":"checkbox-indeterminate"}},[_c('path',{attrs:{"id":"Shape","fill":"#7368F0","d":"M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-2 10H4V8h10v2z"}})])])])
          )
        }
      }
    